<template>
<!-- the goal is to get this to align evenly with <v-checkbox>, which is the origin of the off margin-top -->
<div
    style="margin-top: 20px; margin-bottom: 20px; margin-right: 15px" 
>
    <v-menu 
        bottom 
        offset-y  
    >
    
    <template v-slot:activator="{ on }">

        <div
            v-on="on"
            style="margin-top: 8px"
        >
            <v-icon
                color="primary"
                style="margin-right: 7px; position: relative; top: -1px;"
            >
                mdi-arrow-down-bold-box
            </v-icon>
            <span class="label">{{label}} (<b>{{value_label}}</b>)</span> 
        </div>
            
    </template>
    
    <v-list>
        <v-list-item
            v-on:click="$emit('input',null)"
        >
            <v-list-item-title
                :class="{'hilighted' : value == null}"
            >
                {{label_any}}
            </v-list-item-title>
        </v-list-item>

        <v-list-item
            v-on:click="$emit('input',true)"
        >
            <v-list-item-title
                :class="{'hilighted' : value == true}"
            >
                {{label_true}}
            </v-list-item-title>
        </v-list-item>

        <v-list-item
            v-on:click="$emit('input',false)"
        >
            <v-list-item-title
                :class="{'hilighted' : value == false}"
            >
                {{label_false}}
            </v-list-item-title>
        </v-list-item>
    
    </v-list>
    
    </v-menu> 

    
</div>
</template>

<script>
 export default {
    props: {
        label: {
            type: String,
            default: function() { return "Name"; },
        },

        label_any: {
            type: String,
            default: function() { return "Yes or No"; },
        },

        label_true: {
            type: String,
            default: function() { return "Yes"; },
        },

        label_false: {
            type: String,
            default: function() { return "No"; },
        },

        value: {
            type: Boolean,
            default: function() { return null; }
        }
    },

    computed: {
        value_label() {
            
            if ( this.value == null )
                return this.label_any;
            
            if ( this.value == true )
                return this.label_true;

            if ( this.value == false )
                return this.label_false;

            return 'unknown';
        }   
    },
}
</script>

<style lang="scss" scoped>
.label:hover {
    text-decoration: underline;
    cursor: pointer;
}

.hilighted {
    font-weight: 700;
}
</style>